import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sd-checkbox',
  standalone: false,
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  
  @Output() checkboxChange = new EventEmitter<boolean>();
  
  handleChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.ngOnChange(this.checked);
    this.ngOnTouched();
    this.checkboxChange.emit(this.checked);
  }

  // Implement ControlValueAccessor interface
  private ngOnChange = (_: any) => {};
  private ngOnTouched = () => {};
  
  writeValue(value: boolean): void {
    this.checked = value;
  }
  
  registerOnChange(fn: any): void {
    this.ngOnChange = fn;
  }
  
  registerOnTouched(fn: any): void {
    this.ngOnTouched = fn;
  }
  
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
}
